import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChange, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, FormsModule, Validators } from '@angular/forms';
import { OneWebComponentsAngularModule } from '@one/angular';
import { Subject } from 'rxjs';
import { CommonModule } from '@angular/common';
import { QnSbnService } from '../../../../services/qn-sbn-service.service';
import { snackbarService } from '@one/web-components';
import { AddOwnTemplateDialogComponent } from '../../../../create-notification/add-own-template-dialog/add-own-template-dialog.component';


@Component({
  selector: 'dl-reminder-message-templete-popup',
  standalone: true,
  imports: [OneWebComponentsAngularModule, CommonModule,AddOwnTemplateDialogComponent,FormsModule],
  templateUrl: './reminder-message-templete-popup.component.html',
  styleUrls: ['./reminder-message-templete-popup.component.scss']
})
export class ReminderMessageTempletePopupComponent implements OnInit, OnChanges {
  public formDisabled = false;
   public selectPlaceholder = 'Select type...';
   public selectWidth = '150px';
   @Output() closeDialog = new EventEmitter<void>();
   @Input() isNewFromTemplate: boolean;
   @Input() addRowData: Subject<any>;
   @Input() displayedColumns: any[] = [];
   @Input() tableData: any[] = [];
 
   public dataSource: any[] = [];
   @Output() public isFeedbackOptionAdded = new EventEmitter<{ isOptAdded: boolean }>();
   @Output() public isReminderRowSelected = new EventEmitter<{ messageSelected: any[] }>();
  
   selectedRow: any = null;
   public messageDta: {
     tableData?: any,
     columnData?: any[],
     rowIndex?: number,
     allTemplates?: any[],
     messageType?: string
   } = {};
   
   
   visible: boolean = false;
   deleteButtonVisible = false;
   templateToDelete: any = null;
 
   public selectRadioTextFormControl = new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(500)]);
   public msgAttachDataFormGroup = new FormGroup({
     selectTextFormControl: new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(500)])
   });
 
   public editMessageFlag = false;
   public templateRTE;
 
 
 
   public constructor(private qnsbnservice: QnSbnService, private readonly changeDetectorRef: ChangeDetectorRef) { }
 
  
 
   ngOnInit(): void {
     this.trySetDataSource();
   }
 
   ngOnChanges(changes: SimpleChanges): void {
     if (changes['tableData']) {
       this.trySetDataSource();
     }
   }
 
   private trySetDataSource(): void {
     if (Array.isArray(this.tableData)) {
       this.dataSource = [...this.tableData];
       this.changeDetectorRef.detectChanges();
     } else {
       
     }
   }
 
 
   public deleteReminderFromTemplate(elm: any, index: number): void {
     this.templateToDelete = elm;
     this.deleteButtonVisible = true;
   }
 
   public confirmDelete(): void {
     if (!this.templateToDelete) return;
 
     this.qnsbnservice.deleteMessageTemplate(this.templateToDelete.templateId).subscribe({
       next: (response: any) => {
         if (response?.errorMessage) {
           this.snackBarMessage('alarm', response?.errorMessage?.errorMessage);
 
         } else {
           this.dataSource = this.dataSource.filter(item => item.templateId !== this.templateToDelete.templateId);
           this.changeDetectorRef.detectChanges();
           this.snackBarMessage('positive', 'Reminder template successfully deleted from your templates');
 
         }
         this.deleteButtonVisible = false;
         this.templateToDelete = null;
         this.changeDetectorRef.detectChanges();
       },
       error: (err) => {
         this.qnsbnservice.httpErrorHandler(err, 'Could not fetch reminder templates.');;
         this.deleteButtonVisible = false;
         this.templateToDelete = null;
       }
     });
   }
 
   public closeDeleteModal(): void {
     this.deleteButtonVisible = false;
     this.templateToDelete = null;
   }
 
   public selection = {
     selected: null as any, 
     select: (row: any) => {
       this.selection.selected = row;
     }
   };
 
   public onRadioChange(row: any, event: Event): void {
     if (event) {
       this.selection.select(row);
       this.selectedRow = row;
       this.updateSelectRowStatus();
     }
   }
   
   public updateSelectRowStatus(): void {
     this.isReminderRowSelected.emit({ messageSelected: this.selection.selected });
   }
 
   public EditMessageTemplate(i: number): void {
     this.messageDta = {
       tableData: this.dataSource[i],
       columnData: [],
       rowIndex: i,
       allTemplates: this.dataSource,
       messageType: 'Reminder'
     };
     this.visible = true;
   }
 
   
   public onDialogClosed(): void {
     this.visible = false;
   
     const editEntry = this.messageDta;
   
     if (editEntry && editEntry.rowIndex >= 0) {
       this.dataSource[editEntry.rowIndex] = editEntry.tableData; 
       this.changeDetectorRef.detectChanges();
       this.snackBarMessage('positive', 'Reminder template changes successfully saved');
     }
   }
   
   
 
   public getHTMLRTEText(evt?): void {
     this.templateRTE = evt;
   }
 
   snackBarMessage(status: any, message: string) {
     snackbarService.show({
       message: message,
       snackbarProps: {
         status: status,
         direction: 'horizontal',
         showClose: true,
         elevated: false,
         duration: 5000,
         verticalPlacement: 'top',
         horizontalPlacement: 'right',
       }
     });
   }
 
   public onTemplateUpdated(event: any): void {
     const updated = event?.updatedData;
     if (updated && updated.rowIndex != null) {
       this.dataSource[updated.rowIndex].templateDetails = {
         templateSubject: updated.templateSubject,
         templateBody: updated.templateBody
       };
       this.changeDetectorRef.detectChanges();
     }
   }
   
   
 }
 